import NotAvailable from '../../components/fallback/NotAvailable'

const Games: React.FC = () => {
  return <NotAvailable title={'Games'} />
}

export default Games
